"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorPaletteGreen = exports.ColorPaletteYellow = exports.ColorPaletteRed = exports.ColorPaletteGrey = exports.ColorPaletteOrange = exports.ColorPaletteBlue = exports.ColorPalette2022Branding = exports.ANCHOR_PINK = exports.GOOGLE_BLUE = exports.GREY = exports.WHITE = exports.BLACK = void 0;
exports.BLACK = '0,0,0';
exports.WHITE = '255,255,255';
exports.GREY = '128,128,128';
exports.GOOGLE_BLUE = '66,133,244';
exports.ANCHOR_PINK = '210, 136, 121';
const darkGreen = '#1FA163';
const lightRed = '#E55857';
const darkRed = '#B63C3C';
const darkGray = '#1A1E2C';
const mediumGray = '#757983';
exports.ColorPalette2022Branding = {
    ikeOrange: '#FF9239',
    darkGray,
    lightGray: '#F7F9FC',
    lightIndigo: '#5C5CE8',
    lightBlue: '#2B92F0',
    lightRed,
    lightGreen: '#3DCB87',
    darkIndigo: '#363687',
    darkBlue: '#1966AD',
    darkRed,
    darkGreen,
    g1: darkGray,
    g2: '#2A2F3C',
    g3: '#3C404D',
    g4: '#4E525F',
    g5: '#616571',
    g6: mediumGray,
    g7: '#898D97',
    g8: '#9EA2AA',
    g9: '#B3B7BE',
    g10: '#C9CDD2',
    g11: '#E0E3E7',
    g12: '#F7F9FC',
    success: darkGreen,
    error: lightRed,
    text: mediumGray
};
exports.ColorPaletteBlue = {
    C50: '227,242,253',
    C100: '187,222,251',
    C200: '144,202,249',
    C300: '100,181,246',
    C400: '66,165,245',
    C500: '33,150,243',
    C600: '30,136,229',
    C700: '25,118,210',
    C800: '21,101,192',
    C900: '13,71,161',
    A100: '130,177,255',
    A200: '68,138,255',
    A400: '41,121,255',
    A700: '41,98,255',
    A800: '26, 30, 44'
};
exports.ColorPaletteOrange = {
    C50: '255,243,224',
    C100: '255,224,178',
    C200: '255,204,128',
    C300: '255,183,77',
    C400: '255,167,38',
    C500: '255,152,0',
    C600: '251,140,0',
    C700: '245,124,0',
    C800: '239,108,0',
    C900: '230,81,0',
    A100: '255,209,128',
    A200: '255,171,64',
    A400: '255,145,0',
    A700: '255,109,0'
};
exports.ColorPaletteGrey = {
    C50: '250,250,250',
    C100: '245,245,245',
    C200: '238,238,238',
    C300: '224,224,224',
    C400: '189,189,189',
    C500: '158,158,158',
    C600: '117,117,117',
    C700: '97,97,97',
    C800: '66,66,66',
    C900: '33,33,33'
};
exports.ColorPaletteRed = {
    A700: '213,0,0',
    C200: '199, 99, 99'
};
exports.ColorPaletteYellow = {
    C400: '245,245,33'
};
exports.ColorPaletteGreen = {
    C500: '139,195,74',
    A700: '100,221,23',
    A300: '90, 158, 113'
};
//# sourceMappingURL=theme.palette.js.map